module.exports = __webpack_public_path__ + "static/img/filter-tips.b3938c3f.png";